export enum EPlacementApplicationFormFields {
  CompanyName = 'companyName',
  CompanyType = 'companyType',
  Email = 'email',
  Phone = 'phone',
}
